import React from "react";
import PropTypes from 'prop-types';
import EmailMessageList from "./EmailMessageList";
import EmailManagerApiClient from "./EmailManagerApiClient";
import {MenuItem, SelectField} from "material-ui";
import _ from 'lodash';

export default class PluginItemView extends React.Component {

    static propTypes = {
        configuration: PropTypes.object,
        item: PropTypes.object.isRequired,
        reportEvent: PropTypes.func.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);

        this.emailManagerApiClient = new EmailManagerApiClient();

        this._onFail = this._onFail.bind(this);
        this.refetchThread = this.refetchThread.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.replyToMessage = this.replyToMessage.bind(this);
        this.onTriggerNameChange = this.onTriggerNameChange.bind(this);

        this.state = {
            errorMessage: null,
            fetchingThreads: true,
            threads: null,
            threadIds: null,
            selectedThreadId: null // _.chain(this.props.item).get('data.threadIds').last().value()
        }
    }

    componentDidMount() {
        if (this.hasRequiredData()) {
            this.fetchData();
        }
    }

    hasRequiredData() {
        return _.has(this.props.item, 'data.accountId')
            && _.has(this.props.item, 'data.accountEmail')
            && _.has(this.props.item, 'data.email');
            // && _.has(this.props.item, 'data.threadIds')
            // && _.isArray(this.props.item.data.threadIds)
            // && this.props.item.data.threadIds.length;
    }

    fetchData() {
        let options = {customerEmail: this.props.item.data.email};
        this.emailManagerApiClient.getThreads(this.props.item.data.accountId, options).then(threads => {
            return Promise.all(threads.map(thread => this.fetchThread(thread.id)));
        }).then(threads => {
            this.setState((prevState, props) => ({
                fetchingThreads: false,
                threads: threads,
                selectedThreadId: _.chain(threads).head().get('id', null).value()
            }));

        }).catch(this._onFail);
    }

    fetchThread(threadId) {
        return this.emailManagerApiClient.getThread(this.props.item.data.accountId, threadId);
    }

    refetchThread(threadId) {
        return this.fetchThread(threadId).then(thread => {
            this.setState((prevState, props) => {
                let index = _.findIndex(prevState.threads, {id: thread.id});
                let threads = prevState.threads.slice();
                threads[index] = thread;
                return { threads: threads };
            });
        });
    }

    uploadFile(file) {

    }

    replyToMessage(messageId, from, to, body, files) {
        return this.emailManagerApiClient.replyToMessage(this.props.item.data.accountId, messageId, from, to, body, files).then(() => {
            return this.props.reportEvent('send_email_clicked');
        });
    }

    _onFail(error) {
        this.setState({
            errorMessage: error.message,
            fetchingThreads: false
        });
    }

    onTriggerNameChange(event, index, value) {
        this.setState({ selectedThreadId: value });
    }

    renderThreadsSelectField() {
        if (this.state.threads.length <= 1) {
            return null;
        }
        return (
            <SelectField
                className="custom-select-field"
                floatingLabelText="Thread"
                floatingLabelFixed={true}
                fullWidth={true}
                value={this.state.selectedThreadId}
                onChange={this.onTriggerNameChange}>
                {this.state.threads.map(thread =>
                    <MenuItem key={thread.id} value={thread.id} primaryText={thread.subject + ' (' + thread.id + ')'}/>
                )}
            </SelectField>
        );
    }

    renderEmailMessageList(thread) {
        return (
            <EmailMessageList
                accountEmail={this.props.item.data.accountEmail}
                thread={thread}
                refetchThread={this.refetchThread}
                uploadFile={this.uploadFile}
                replyToMessage={this.replyToMessage}
            />
        );
    }

    renderThreads() {
        if (this.state.threads.length <= 1) {
            return this.renderEmailMessageList(this.state.threads[0]);
        }
        return this.state.threads.map(thread =>
            <div key={thread.id} style={{display: thread.id === this.state.selectedThreadId ? 'block' : 'none'}}>
                {this.renderEmailMessageList(thread)}
            </div>
        );
    }

    render() {

        if (!this.hasRequiredData()) {
            return (<div>Error: item does not have required data...</div>);
        }

        if (this.state.fetchingThreads) {
            return (<div>Loading...</div>);
        }

        if (this.state.errorMessage) {
            return (<div> Error: {this.state.errorMessage} </div>);
        }

        if (this.state.threads.length === 0) {
            return (<div>No email threads were found</div>);
        }

        return (
            <div>
                {this.renderThreadsSelectField()}
                {this.renderThreads()}
            </div>
        );
    }

};



// WEBPACK FOOTER //
// ./src/components/plugins/emailPlugin/PluginItemView.js